var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', _vm._b({
    attrs: {
      "title": "문자발송",
      "fullscreen": "",
      "persistent": "",
      "width": "1224",
      "maxWidth": "100%",
      "needsLogin": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, 'bottom-sheet', {
    userType: _vm.userType
  }, false), [_c('v-layout', {
    staticClass: "bottom-sheet__contents",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_c('texting-form', _vm._b({
    on: {
      "posted": _vm.updateItem
    }
  }, 'texting-form', {
    applications: _vm.applications,
    meeting: _vm.meeting,
    recruitment: _vm.recruitment,
    initialForm: _vm.initialForm
  }, false)), _c('texting-list', _vm._b({
    staticClass: "mt-40 mt-lg-60",
    attrs: {
      "showsAddressees": ""
    }
  }, 'texting-list', {
    textings: _vm.textings
  }, false)), _c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11,
      "color": "primary"
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }